<template>
  <div class="form__group--border pt-32 pb-16">
    <fieldset>
      <legend class="form__label pb-8">Will you work in a home that has pets?</legend>
      <poppins-radio-button
        id="yes-pets"
        ref="yesPets"
        v-model="comfortableWithPets"
        :checked="comfortableWithPets === 'true'"
        radioName="comfortableWithPets"
        labelName="Yes, I love pets"
        radioValue="true"
        ariaDescribedByName="radio-group-helper"
        :required="true"
      />
      <poppins-radio-button
        id="no-pets"
        v-model="comfortableWithPets"
        :checked="comfortableWithPets === 'false'"
        labelName="No, I'm not comfortable with pets"
        radioName="comfortableWithPets"
        radioValue="false"
        class="mr-32 my-16"
        ariaDescribedByName="radio-group-helper"
        :required="true"
        @blur="validate"
      />
      <HelperText
        v-if="hasErrors"
        id="radio-group"
        class="!-mt-8 mb-16"
        text="Select one of the options above"
        :status="helperStatus.Error"
      />
    </fieldset>
  </div>
</template>

<script lang="ts">
import helperStatus from '@/helpers/status';
import RadioButton from '@/components/radio_button/RadioButton.vue';
import HelperText from '@/components/helper_text/HelperText.vue';
import focusOnElement from '@/helpers/focusHelper';

export default {
  name: 'ComfortablePetsRadio',
  components: {
    PoppinsRadioButton: RadioButton,
    HelperText,
  },
  data(): any {
    return {
      helperStatus,
      formStatuses: {
        comfortableWithPets: helperStatus.Neutral,
      },
    };
  },
  computed: {
    comfortableWithPets: {
      get() {
        return this.$store.getters.getFormField('comfortableWithPets');
      },
      set(newValue) {
        this.formStatuses.comfortableWithPets = helperStatus.Neutral;
        return this.$store.dispatch('updateForm', { key: 'comfortableWithPets', value: newValue });
      },
    },
    fieldIsValid(): boolean {
      return this.comfortableWithPets !== null;
    },
    hasErrors(): boolean {
      return this.formStatuses.comfortableWithPets === helperStatus.Error;
    },
  },
  methods: {
    validate() {
      if (!this.fieldIsValid) {
        this.formStatuses.comfortableWithPets = helperStatus.Error;
      }
      return this.formStatuses.comfortableWithPets;
    },
    focusElement() {
      focusOnElement(this.$refs.yesPets.$el.querySelector('input'));
    },
  },
};
</script>
